import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

// Bloque l'accès à l'appli tant que la politique de confidentialité en
// vigueur n'a pas été acceptée — à la toute première connexion, puis à
// chaque mise à jour de la politique (avis clair de ce qui a changé).
const ConsentementGate = ({ children }) => {
  const [statut, setStatut] = useState(null); // null = en chargement
  const [accepte, setAccepte] = useState(false);
  const [envoi, setEnvoi] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/auth/consentement')
      .then(res => setStatut(res.data))
      .catch(() => setStatut({ doit_accepter: false }));
  }, []);

  const valider = async () => {
    setEnvoi(true);
    try {
      await api.post('/auth/consentement/accepter');
      setStatut(prev => ({ ...prev, doit_accepter: false }));
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setEnvoi(false);
    }
  };

  if (statut === null) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-gray-400 text-sm">Chargement...</div>
      </div>
    );
  }

  if (!statut.doit_accepter) {
    return children;
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center px-6">
      <div className="max-w-md mx-auto w-full">
        <h1 className="text-lg font-medium text-gray-900 mb-2">
          {statut.premiere_fois ? 'Avant de commencer' : 'Notre politique a été mise à jour'}
        </h1>

        {!statut.premiere_fois && statut.resume_changement && (
          <div className="bg-blue-50 border border-blue-100 rounded-xl p-3 mb-4">
            <p className="text-xs text-blue-700">{statut.resume_changement}</p>
          </div>
        )}

        <p className="text-sm text-gray-600 mb-4">
          {statut.premiere_fois
            ? "Cette plateforme collecte certaines données pour fonctionner (voir le détail dans notre politique de confidentialité)."
            : "Nous avons mis à jour notre politique de confidentialité. Merci de la consulter et de confirmer que vous l'acceptez pour continuer."}
        </p>

        <button onClick={() => navigate('/confidentialite')} className="text-sm text-gray-900 underline mb-6 block">
          Lire la politique de confidentialité complète
        </button>

        <label className="flex items-start gap-2 bg-white rounded-xl border border-gray-100 p-4 mb-4">
          <input type="checkbox" checked={accepte} onChange={(e) => setAccepte(e.target.checked)} className="mt-0.5" />
          <span className="text-sm text-gray-700">J'ai lu et j'accepte la politique de confidentialité.</span>
        </label>

        <button onClick={valider} disabled={!accepte || envoi}
          className="w-full bg-gray-900 text-white rounded-xl py-3 text-sm font-medium disabled:opacity-40">
          {envoi ? 'Enregistrement...' : 'Continuer'}
        </button>
      </div>
    </div>
  );
};

export default ConsentementGate;